import {
  OreButton,
  OreHeading,
  OreModal,
  OreModalBox,
  OreModalBoxBody,
  OreModalBoxFooter,
  OreText,
} from '@edenredespana/oreneta'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import {
  formTranslation,
  protectedProcessTranslation,
} from '@/Shared/ui/sharedTranslation'

export interface ProtectedNavigationModalProps {
  title: string
  description: string
}

export type ProtectedNavigationModalActions = {
  open: (destination: string, title: string, description: string) => void
}

export const ProtectedNavigationModal = forwardRef<ProtectedNavigationModalActions>(
  (_, ref): JSX.Element => {
    const { t } = useTranslation()
    const [open, setOpen] = useState<boolean>(false)
    const [destination, setDestination] = useState<string>('')
    const [copies, setCopies] = useState<{ title: string; description: string }>({
      title: t(protectedProcessTranslation.title),
      description: t(protectedProcessTranslation.description),
    })

    const navigate = useNavigate()

    useImperativeHandle(ref, () => ({
      open: async (
        destination: string,
        title?: string,
        description?: string,
      ): Promise<void> => {
        setOpen(true)
        setDestination(destination)

        if (title && description) {
          setCopies({ title, description })
        } else if (title) {
          setCopies({ title, description: copies.description })
        } else if (description) {
          setCopies({ title: copies.title, description })
        }
      },
    }))

    const saveAndClose = async (
      event: React.MouseEvent<HTMLButtonElement>,
    ): Promise<void> => {
      event?.preventDefault()
      navigate(destination)
      setOpen(false)
    }

    return (
      <OreModal open={open} handleOnClose={() => setOpen(false)}>
        <OreModalBox size="medium" handleOnClose={() => setOpen(false)}>
          <OreModalBoxBody>
            <OreHeading size="headline-lg">{copies.title}</OreHeading>
            <OreText>{copies.description}</OreText>
          </OreModalBoxBody>
          <OreModalBoxFooter>
            <OreButton onClick={() => setOpen(false)} size="small" category="secondary">
              {t(formTranslation.common.buttons.cancel)}
            </OreButton>
            <OreButton onClick={saveAndClose} size="small" category="primary">
              {t(formTranslation.common.buttons.confirm)}
            </OreButton>
          </OreModalBoxFooter>
        </OreModalBox>
      </OreModal>
    )
  },
)
